module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;   var u = require('util/Util.js').default;
    var listService = require('ListService.js').default;
    var languages = listService.getAllLanguages();

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Language</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <div style=\"display: inline-flex;\">\r\n            <select name=\"language\" id=\"language\" >\r\n                <option value=\"default\">Default</option>\r\n                ")
    ;  for (var i = 0; i < languages.length; i++) { 
                    if(languages[i].active){
                       
                    if(listService.currentLanguage === languages[i].code){
                        
    ; __append("\r\n                    <option value=\"")
    ; __append(escapeFn(languages[i].code))
    ; __append("\" selected=\"selected\" >")
    ; __append(escapeFn(languages[i].name))
    ; __append("</option>\r\n                ")
    ; 
                    }else{
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(languages[i].code))
    ; __append("\" >")
    ; __append(escapeFn(languages[i].name))
    ; __append("</option>\r\n            ")
    ;  }} }; 
    ; __append("\r\n            </select>\r\n            <div class=\"nopadding button-opener\">\r\n                <button id=\"multilanguageManager\" class=\"btn btn-default hvr-glow button-selector\">...</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n        \r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}